import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'yesNo', pure: false })
export class YesNoPipe implements PipeTransform {
  transform(value: boolean): string {
    if (value) {
      return 'Yes';
    }
    return 'No';
  }
}
